import { useEffect, useRef } from 'react';
import { Animated, Dimensions, Easing, Platform, StyleSheet } from 'react-native';

import { useTabTransition } from '@/contexts/TabTransitionContext';

const SCREEN_W = Dimensions.get('window').width;

export function TabScreenWrapper({ children }: { children: React.ReactNode }) {
  const { consumeDirection } = useTabTransition();
  const translateX = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    const dir = consumeDirection();
    if (!dir) return;
    translateX.setValue(dir === 'right' ? SCREEN_W : -SCREEN_W);
    Animated.timing(translateX, {
      toValue: 0,
      duration: 280,
      easing: Easing.out(Easing.cubic),
      useNativeDriver: Platform.OS !== 'web',
    }).start();
  // consumeDirection is stable (reads a ref) — safe to omit
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Animated.View style={[styles.fill, { transform: [{ translateX }] }]}>
      {children}
    </Animated.View>
  );
}

const styles = StyleSheet.create({
  fill: { flex: 1 },
});
